class AweFooter extends HTMLElement {

  constructor() {
    super()

    this.attachShadow({ mode: 'open' })
    this.contentNd = document.createElement('div')
    this.contentNd.classList.add('content')
    this.contentNd.innerHTML = `<slot></slot>`

    const style = document.createElement('style')

    style.textContent = `
      :host {
        overflow: hidden;
        display: block;
      }
      .content{
        overflow: hidden;
        padding-bottom: var(--footer-bottom-padding, .6em);
        position: relative; 
      }
      
      #btn{
        color: white;
        border: none;
        background: none;
        text-decoration: underline;
        display: none;
        margin-bottom: 3px;
        cursor: pointer;
        font-family: var(--font-default);
      }

      @media (max-width: 600px){
        .long{
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          padding-bottom: 0;
        }
        .long.expanded{
          display: block;
        }
        #btn{
          display: inline-block;
        }
      }
    `

    this.shadowRoot.append(style, this.contentNd)
  }

  connectedCallback() {
    if (!this.isConnected) return

    const longAttr = this.getAttribute('long')
    const isLong = longAttr === '' || longAttr === 'true'

    this.contentNd.classList.toggle('long', isLong)
    this.toggleButton(isLong)
  }

  // set or remove button according to slotted content length
  toggleButton(isLong) {
    let btn = this.shadowRoot.getElementById('btn')

    if (isLong && !btn) {
      btn = document.createElement('button')
      btn.id = 'btn'
      const txt = i18n.get('AWE-FOOTER.SEE_MORE')

      btn.textContent = txt
      btn.setAttribute('aria-label', txt)

      this.shadowRoot.append(btn)
      btn.addEventListener('click', e => { this.toggleFullText(e) })

    }
    else if (!isLong && btn)
      btn.remove()
  }

  toggleFullText(e) {
    let height

    if (!this.contentNd.classList.contains('expanded'))
      height = this.shadowRoot.host.getBoundingClientRect().height

    const expanded = this.contentNd.classList.toggle('expanded')

    this.dispatchEvent(new CustomEvent('footer-expand', { bubbles: true, detail: {
      expanded,
      height,
    } }))
    e.currentTarget.textContent = i18n.get(expanded ? 'AWE-FOOTER.SEE_LESS' : 'AWE-FOOTER.SEE_MORE')
  }
}
customElements.define('awe-footer', AweFooter)

const footerNd = document.getElementsByTagName('awe-footer')[0]

if (footerNd) {
  // on footer-expand event, set layout margin bottom to exactly the height of the collapsed footer,
  // so that there is no layout shift for the stores when moving the footer out of the grid.
  footerNd.addEventListener('footer-expand', e => {
    e.currentTarget.classList.toggle('expanded', e.detail.expanded)
    if (e.detail.height)
      document.body.style.setProperty('--layout-margin-bottom', `${e.detail.height.toFixed(1)}px`)
    else
      document.body.style.removeProperty('--layout-margin-bottom')
  })
}
